export const API_URL = "https://pointcapitalis.com/adminApi/";
//export const API_URL = "http://localhost:8080/adminApi/";
export const API_IMG_URL = "https://pointcapitalis.com/profile/"
export const IMAGE_URL = "http://myadmin.poolsifi.com/image/";
//export const IMAGE_URL = "http://localhost:3000/image/";

